import type {
  AuthorRelationResponseCollection,
  ComponentCommonAuthorDetailed,
  KnowledgeBase,
  KnowledgeBaseEntity,
} from '@edwin-group/people-graphql';

export function getAuthors(knowledgebase?: KnowledgeBase | KnowledgeBaseEntity) {
  const authors = knowledgebase?.attributes?.DefaultContentTemplate?.filter(
    (component) => component?.__typename === 'ComponentCommonAuthorDetailed',
  ).map((component: unknown) => {
    return ((component as ComponentCommonAuthorDetailed)?.authors as unknown as AuthorRelationResponseCollection)?.data
      .map((author) => author.attributes?.name)
      .join(', ');
  });

  return authors?.flatMap((author) => author).join(' ') || '';
}
